import localforage from "localforage";

class BigStorage {
  constructor() {
    this.cache = new Map();
    this.ready = this._init();
  }

  async _init() {
    await localforage.iterate((value, key) => {
      this.cache.set(key, value);
    });
  }

  async setItem(key, value) {
    this.cache.set(key, value);
    return localforage.setItem(key, value);
  }

  getItem(key) {
    return this.cache.get(key) ?? null;
  }

  async removeItem(key) {
    this.cache.delete(key);
    return localforage.removeItem(key);
  }

  async clear() {
    this.cache.clear();
    return localforage.clear();
  }
}

export const bigStorage = new BigStorage();
